import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Alert, Row, Col, Space, Divider, Typography, Button, Spin, Layout } from "antd";

import moment from "moment";
import { PrinterOutlined } from '@ant-design/icons';
import { apiCall } from "../utils/Api";
import { useSession } from "../utils/Session";
import { parseAuthorsPlain, parseSubjectsPlain } from "../utils/Utils";

export default function ListPrint(props) {


    const [session, setSession] = useSession();
    const { list_id = "" } = useParams();
    const imagesLoadedCount = useRef(0);
    const [isPrintEnabled, setIsPrintEnabled] = useState(false);
    const [progress, setProgress] = useState(0);


    useEffect(() => {
        // Remove dark mode
        document.body.classList.remove('dark');
        return () => {
            document.body.classList.remove('dark');
        };
    }, []);


    const [results, setResults] = useState(
        {
            rows: []
        }
    );

    const [list, setList] = useState({
        name: "",
        isbns_count: 0,
        owner_name: ""
    })


    const [loading, setLoading] = useState(true);
    const [error, setErrror] = useState(false);


    useEffect(() => {
        const total = results.rows.length;
        if (total > 0 && imagesLoadedCount.current >= total) {
            setIsPrintEnabled(true);
            setProgress(total)
        }
    }, [results.rows.length]);

    const handleImageLoad = () => {
        imagesLoadedCount.current += 1;
        const total = results.rows.length;
        // only check & update print button when we're done
        if (imagesLoadedCount.current >= total) {
            setIsPrintEnabled(true);
            setProgress(total);
        }
    };


    const getList = () => {

        document.title = "Print Preview";

        apiCall("titlelist/getItems", { list_id: list_id, limit: 500 }, (_status, _result) => {
            if (_status) {
                setResults(_result)
            } else {
                setErrror(_result.error);
            }
        })

        apiCall("titlelist/get", { list_id: list_id }, (_status, _result) => {
            if (_status) {
                setList(_result);
            }
        })
    }

    useEffect(getList, []);




    const noCover = (e) => {
        e.target.src = "https://cdn1.bookmanager.com/i/nocover.png";
        e.target.onerror = null;
    }


    const DrawRow = (props) => {


        const {
            title = "",
            authors = [],
            isbn = "",
            eisbn = "",
            publisher = "",
            binding = "",
            release_date = "",
            series = "",
            subjects = [],
            list_price_can = "",
            list_price_usa = "",

        } = props.data;


        const [imageLoaded, setImageLoaded] = useState(true);
        const price = (session?.is_canadian) ? list_price_can : list_price_usa;

        return (
            <div style={{ "width": "295px", "height": "225px", "overflow": "hidden" }}>

                <Row gutter={15} key={isbn}>
                    <Col flex={"95px"}>
                        <Space direction="vertical">

                            {((!imageLoaded) &&
                                <div className={"card-fallback-small"} style={{ height: "140px", width: "95px", "overflow": "hidden" }} draggable={false} >
                                    <div style={{ "fontSize": "12px", "lineHeight": "16px", "whiteSpace": "normal", "maxWidth": "100%" }}>{title || ""}</div>
                                    <div className="shim" /><div className="shim" />
                                    <div style={{ "fontSize": "11px", "whiteSpace": "normal", "maxWidth": "70%", "opacity": "0.8" }}><small><em>{parseAuthorsPlain(authors || [])}</em></small></div>
                                </div>
                            )}

                            {(imageLoaded &&
                                <img onLoad={handleImageLoad} className="shadow-large" style={{ "maxWidth": "95px" }} onError={(e) => {
                                    e.target.onerror = null;
                                    handleImageLoad();
                                    setImageLoaded(false)
                                }} src={"https://bookmanager.com/i/m?b=" + eisbn} />

                            )}
                        </Space>
                    </Col>
                    <Col flex={"200px"}>
                        <div style={{ "lineHeight": "14px" }}><strong>{title}</strong></div>
                        <div style={{ "marginTop": "-5px" }}><small>{parseAuthorsPlain(authors)}</small></div>
                        <div style={{ "marginTop": "-10px" }}><small><em>{binding}</em></small></div>
                        <div className="shim" />
                        {((series) && <div style={{ "marginTop": "-5px" }}><small><em>Series: </em>{series}</small></div>)}
                        <div style={{ "marginTop": "-5px", "lineHeight": "12px" }}><small>{parseSubjectsPlain(subjects)}</small></div>
                        <div className="shim" />
                        {(session?.has_bm_data_lite || session?.has_bm_data_full) && <div style={{ "marginTop": "-5px" }}><small><em>ISBN: </em>{isbn}</small></div>}
                        <div style={{ "marginTop": "-5px" }}><small><em>Published: </em>{moment(release_date * 1000).format("MMM Do, YYYY")}</small></div>
                        {(price > 0 && <div style={{ "marginTop": "-5px" }}><small><strong>${(session?.is_canadian) ? list_price_can : list_price_usa}</strong></small></div>)}




                    </Col>
                </Row>
                <Divider dashed />
            </div>
        )
    }

    if (error) {
        return (<div style={{ "margin": "0 auto", "width": "350px", "marginTop": "calc(20vh)" }}><Alert type="error" description={error} /></div>)
    }


    const printPage = () => {
        window.print();
    }


    return (<>


        <div className="container">

            <Spin tip={<>Loading Images {progress} of {results.rows.length}</>} spinning={!isPrintEnabled}>
                <div id="content">
                    <div id="print" style={{ "padding": "0px 20px" }}>

                        <div style={{ "height": "250px", "overflow": "hidden" }}>
                            <div className="shim" style={{ "height": "20px" }} />
                            <div style={{ "float": "right", "padding": "20px" }}><Button disabled={!isPrintEnabled} className="no-print" onClick={() => printPage()} icon={<PrinterOutlined />} type="primary">Print</Button></div>
                            <Typography.Title level={2}>{session.store_name}</Typography.Title>
                            <div style={{ "marginTop": "-10px" }}>
                                <div><strong>{list.name}</strong> </div>
                                <div>{(list.owner_name && <>Managed by: {list.owner_name} {((list.isbns_count) && <> | <em>({Math.min(list.isbns_count, 500)} titles)</em></>)}</>)}</div>
                                {(results.purchase_deadline && <><div>Purchase deadline : <strong>{moment(results.purchase_deadline * 1000).format("MMM Do, YYYY")}</strong></div></>)}
                                <div>&nbsp;</div>

                            </div>
                            <Divider />
                        </div>
                        <div className="grgrid">
                            {results.rows.map(item => { return <DrawRow data={item} /> })}
                        </div>
                        <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                    </div>
                </div>
            </Spin>

        </div>

    </>
    )
}